module.exports = __webpack_public_path__ + "images/f3741458.inviteIcon.webp";


//////////////////
// WEBPACK FOOTER
// ./src/pages/inviteCodePage/images/inviteIcon.webp
// module id = ekBH
// module chunks = 0